import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { Calendar, DateObject } from 'react-multi-date-picker';
import moment from 'moment';
import gregorian_ru from './gregorian_ru';
import './RangeDatePickerStyles.scss';

export default function CalendarDatePicker(props) {
  const {
    className = '',
    inline = false,
    hidePeriodButtons = false,
    inputProps = {},
    fieldState = {
      error: '',
      touched: false,
    },
    changeFormat = null,
    onChangeToIso = false,
  } = props;
  const { formatMessage } = useIntl();
  const { onChange = () => {}, name, value } = inputProps;
  const [values, setValues] = useState([]);

  useEffect(() => {
    const defaultValue = value && value.length && value.every(obj => typeof obj === 'string')
      ? [
        new DateObject(moment(value[0]).startOf('day').toDate()),
        new DateObject(moment(value[1]).endOf('day').toDate()),
      ] : [];
    setValues(defaultValue);
  }, [value]);

  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [pickerKey, setPickerKey] = useState(null);

  const onSelect = range => {
    if (range && range.length && range.length > 1) {
      setValues(range);
      const [start, end] = range;
      if (changeFormat) {
        onChange({ target: { value: [start.format(changeFormat), end.format(changeFormat)], name } });
      } else if (onChangeToIso) {
        onChange({ target: { value: start && end ? [moment(start.toDate()).startOf('day').toISOString(), moment(end.toDate()).endOf('day').toISOString()] : '', name } });
      } else {
        onChange({ target: { value: range, name } });
      }
    }
  };

  const handleChangeDate = range => {
    setSelectedPeriod(null);
    onSelect(range);
  };

  const onReset = event => {
    setValues('');
    setSelectedPeriod('');
    onChange({ target: { value: '', name } });
    event.stopPropagation();
  };

  const handleSelectPeriod = type => () => {
    const today = moment();
    let start = today.clone().startOf('day');
    let end = today.clone().endOf('day');
    if (type === 'y') {
      start = today.clone().startOf('year');
      end = today.clone().endOf('year');
    }
    if (type === 'm') {
      start = today.clone().startOf('month');
      end = today.clone().endOf('month');
    }
    if (type === 'w') {
      start = today.clone().startOf('week');
      end = today.clone().endOf('week');
    }
    if (type === 'yd') {
      start = today.clone().startOf('days')
        .subtract(1, 'days');
      end = today.clone().endOf('days')
        .subtract(1, 'days');
    }
    setSelectedPeriod(type);
    onSelect([new DateObject({ date: start.toDate() }), new DateObject({ date: end.toDate() })]);
    setTimeout(() => {
      setPickerKey(pickerKey + 1);
    }, 50);
  };

  return (
    <div className="data-picker-wrapper">
      <Calendar
        key={pickerKey}
        value={values}
        onChange={handleChangeDate}
        locale={gregorian_ru}
        range
        rangeHover
        weekStartDayIndex={1}
      />
      {!hidePeriodButtons
        ? (
          <div className="data-picker-filter-buttons">
            <span
              className={classNames('data-picker-filter-button', { active: selectedPeriod === 'yd' })}
              onClick={handleSelectPeriod('yd')}
            >
              {formatMessage({ id: 'yesterday' })}
            </span>
            <span
              className={classNames('data-picker-filter-button', { active: selectedPeriod === 'd' })}
              onClick={handleSelectPeriod('d')}
            >
              {formatMessage({ id: 'today' })}
            </span>
            <span
              className={classNames('data-picker-filter-button', { active: selectedPeriod === 'w' })}
              onClick={handleSelectPeriod('w')}
            >
              {formatMessage({ id: 'week' })}
            </span>
            <span
              className={classNames('data-picker-filter-button', { active: selectedPeriod === 'm' })}
              onClick={handleSelectPeriod('m')}
            >
              {formatMessage({ id: 'month' })}
            </span>
            <span
              className={classNames('data-picker-filter-button', { active: selectedPeriod === 'y' })}
              onClick={handleSelectPeriod('y')}
            >
              {formatMessage({ id: 'year' })}
            </span>
            <span
              className={classNames('data-picker-filter-button reset')}
              onClick={onReset}
            >
              {formatMessage({ id: 'clear' })}
            </span>
          </div>
        )
        : null}
    </div>
  );
}
